import React from 'react'

import { ZariContext } from '_zari/context'

import { Button, Col, Row } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as UtilServices from 'services/util.service'

const DownloadRowAddon = ({ filas, headRows, title }) => {
  const __zariContext = React.useContext(ZariContext)

  const clickDescargarExcel = React.useCallback(() => {
    const validHeaders = headRows
      .filter(x => !!x.label)
      .map(x => ({
        key: x.key,
        title: x.label
      }))

    __zariContext.loader.open('Convirtiendo tabla a EXCEL.')

    UtilServices.convertirTablaAExcel({
      title: title || 'Conversion Excel',
      headers: validHeaders || [],
      rows: filas || []
    })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
        __zariContext.toast('success', 'Tabla convertida a EXCEL.')
      })
      .catch(() => {
        __zariContext.toast('error', 'No se pudo convertir la tabla.')
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, title, headRows, filas])

  return (
    <Row className='mb-2'>
      <Col md={12} className='text-right'>
        <Button color='success' outline tiny onClick={clickDescargarExcel}>
          Descargar EXCEL
        </Button>
      </Col>
    </Row>
  )
}

export default React.memo(DownloadRowAddon)
